export default __webpack_public_path__ + "static/5-cssbattle-4f8ea9e502365a5b1b577f22533c4041.png";